var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "serialNumberChangeModal",
        size: "md",
        "content-class": "sub-menu-bg-blue-transparent snc-modal",
        title: "Update Serial Number",
        "hide-footer": "",
        "no-fade": "",
        "header-close-variant": "light",
      },
    },
    [
      _c("div", { staticClass: "snc-body" }, [
        _c(
          "div",
          { staticClass: "snc-info-strip" },
          [
            _c("fa", {
              staticClass: "snc-info-icon",
              attrs: { icon: ["fas", "exchange-alt"] },
            }),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                "The current serial number will be replaced with a new one."
              ),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "snc-info-card" }, [
          _c("div", { staticClass: "snc-info-row" }, [
            _c("span", { staticClass: "snc-label" }, [_vm._v("System")]),
            _vm._v(" "),
            _c("span", { staticClass: "snc-value" }, [
              _vm._v(_vm._s(_vm.system)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "snc-info-row" }, [
            _c("span", { staticClass: "snc-label" }, [_vm._v("Scanner")]),
            _vm._v(" "),
            _c("span", { staticClass: "snc-value" }, [
              _vm._v(_vm._s(_vm.scanner)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "snc-info-row" }, [
            _c("span", { staticClass: "snc-label" }, [_vm._v("Current SN")]),
            _vm._v(" "),
            _c("span", { staticClass: "snc-value" }, [
              _vm._v(_vm._s(_vm.serialNumber)),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "snc-field" },
          [
            _c("label", { staticClass: "snc-field-label" }, [
              _vm._v("New Serial Number"),
            ]),
            _vm._v(" "),
            _c("b-form-input", {
              staticClass: "snc-input",
              attrs: {
                placeholder: "Type new serial number...",
                autocomplete: "off",
              },
              model: {
                value: _vm.newSerialNumber,
                callback: function ($$v) {
                  _vm.newSerialNumber = $$v
                },
                expression: "newSerialNumber",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "snc-actions" },
          [
            _c(
              "b-button",
              {
                staticClass: "snc-submit-btn",
                attrs: { disabled: !_vm.newSerialNumber.trim() },
                on: {
                  click: function ($event) {
                    return _vm.submitNewSerialNumber()
                  },
                },
              },
              [_vm._v("\n        Update Serial Number\n      ")]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }